<template>
  <div class="modal--delete">
    <!--      Password Modal Part-->
    <div class="modalCustom__header">
      <h5 class="">{{ header }}</h5>
      <hr class="modalCustom__header-border" />
    </div>

    <div class="modalCustom__body">
      <div class="modal--delete__question">
        <p>
          Are you sure you want to {{ delete_button_name }} {{ deletion_object_text }} <br />
          (<span class="text-custom_red">{{ deletion_object_name }}</span
          >) ?
        </p>
      </div>

      <div class="modal--delete__confirm">
        <h6>{{ $t('please_confirm_this_action') }}:</h6>
        <fg-input
          type="text"
          :label="'Type ' + delete_button_name + ' to confirm'"
          :placeholder="placeholder"
          v-model="confirmed"
        >
        </fg-input>
      </div>
    </div>

    <div class="modalCustom__footer">
      <div class="mr-3">
        <p-button type="danger" round @click.native.prevent="closeModal">
          {{ $t('Cancel') }}
        </p-button>
      </div>
      <div v-if="confirmed.toLowerCase() === confirmation_word.toLowerCase()">
        <p-button type="success" round @click.native.prevent="deleteObj">
          {{ $t(delete_button_name) }}
        </p-button>
      </div>
      <div v-else>
        <p-button type="success" :disabled="true" round>
          {{ $t(delete_button_name) }}
        </p-button>
      </div>
    </div>
    <!--      End Password Modal Part-->
  </div>
</template>

<script>
import CancelButton from '../buttons/CancelButton';
import DeleteButton from '../buttons/DeleteButton';
export default {
  name: 'DeleteModal',
  components: { DeleteButton, CancelButton },
  props: {
    data: {
      type: Object,
    },
  },
  data: function () {
    return {
      confirmed: '',
      deletion_object_text: '',
      deletion_object_name: '',
      header: '',
      placeholder: this.$t('delete'),
      confirmation_word: this.$t('delete'),
      delete_button_title: this.$t('Delete'),
      delete_button_name: this.$t('Delete'),
    };
  },
  mounted() {
    this.setData(this.data);
  },
  methods: {
    setData: function (data) {
      // Required
      this.deletion_object_text = data.deletion_object_text;
      this.deletion_object_name = data.deletion_object_name;
      this.header = data.header;
      this.deletion_object_name = data.deletion_object_name;
      // End Required

      if (data.placeholder) this.placeholder = data.placeholder;
      if (data.confirmation_word) this.confirmation_word = data.confirmation_word;
      if (data.delete_button_title) this.delete_button_title = data.delete_button_title;
      if (data.delete_button_name) this.delete_button_name = data.delete_button_name;
    },
    closeModal: function () {
      this.confirmed = '';
      this.$emit('close');
    },
    deleteObj: function () {
      this.closeModal();
      this.$emit('submit');
    },
  },
};
</script>

<style scoped></style>
